import * as React from 'react';
import { IStackStyles, MessageBar, MessageBarType } from 'office-ui-fabric-react';
import './Item.scss';
import history from '../../../../lib/history';
import { DetailsList, DetailsListLayoutMode, SelectionMode, IColumn } from 'office-ui-fabric-react/lib/DetailsList';

import { MaxOrderItems, ProgressStatus } from '../../../../constants/GlobalConstants';
import { _getInputService } from '../../../../services/event.service';
import Header from '../../../common/Header';
import { IItemProps, IItemState } from '../../../../interfaces/IItem';
import Loader from '../../../common/loader/Loader';
import { IOrderItem } from '../../../../interfaces/INewOrderAddItems';
import EditItemPopup from '../../orders/edititem/EditItemPopup';
import { setStorage } from '../../../../lib/LocalStorageService';

export default class Item extends React.Component<IItemProps, IItemState> {

  stackStyles: Partial<IStackStyles> = { root: {} };

  constructor(props: IItemProps) {
    super(props);
    this.getItems();

    this.state = {
      columns: this.getColumns(),
      isCompactMode: false,
      ProgressStatus: ProgressStatus.Init,
      Items: [],
      SelectedItem: initialSelectedItem,
      hideDialog: true,
      Quantity: 0,
      ErrorMessageOnQuantity: '',
      Description: '',
      CategoryName: this.getCategoryName()
    };
  }

  private _getKey(item: any, index?: number): string {
    return item.key;
  }

  private _onItemInvoked(item: any): void {
    alert(`Item invoked: ${item.name}`);
  }

  private getColumns(): IColumn[] {
    const columns: IColumn[] = [
      {
        key: 'columnItems',
        name: 'Items',
        fieldName: 'dateModifiedValue',
        minWidth: 70,
        maxWidth: 90,
        isResizable: true,
        data: 'number',
        onRender: (item: IOrderItem) => {
          return <div className="col-12 mt-12 text-center cursor-pointer" onClick={() => this.addQuantity(item)} >
            <p className="mb-0 ms-fontSize-16 text-black text-left">{item.Title}</p>
            <p className="mb-0 text-muted text-left">{item.ArticleNumber_MXI} / {item.ArticleNumber_RAI}</p>
          </div>;
        },
        isPadded: true
      }
    ];
    return columns;
  }

  private getItems(): IOrderItem[] {
    this.setState({ ProgressStatus: ProgressStatus.Loading });
    _getInputService().then(res => {
      let filterItems: IOrderItem[] = res.Items.map(
        (data: any) => {
          return {
            Id: data.ID,
            Title: data.Title,
            ArticleNumber_MXI: data.Artikelnummer_x0020_MXI,
            ArticleNumber_RAI: data.Artikelnummer_x0020_RAI,
            Artikelgroep: data.Artikelgroep
          }
        });
      const selectedCategory = this.getCategoryName();
      filterItems = filterItems.filter(function (el) {
        return el.Artikelgroep == selectedCategory;
      });

      this.setState({
        ProgressStatus: ProgressStatus.Loaded,
        Items: filterItems
      })
      return filterItems;
    });
    return [];
  }

  private getCategoryName = (): string | null => new URLSearchParams(history.location.search).get("category");

  private addQuantity = (selectedItem: IOrderItem): void => {
    this.setState({ hideDialog: false, SelectedItem: selectedItem });
  };

  private cancelAdding = (): void => {
    this.setState({ hideDialog: true, Quantity: 0, ErrorMessageOnQuantity: '', Description: '', SelectedItem: initialSelectedItem });
  }

  private goForAddingItem = (): void => {
    const { Quantity, Description, SelectedItem } = this.state;
    if (Quantity > 0) {
      let quantity = Quantity;
      let description = Description;
      let _orderBasic = history.location.state.OrderBasic;
      let _items = history.location.state.Items;
      this.setState({ hideDialog: true, Quantity: 0, ErrorMessageOnQuantity: '', Description: '', SelectedItem: initialSelectedItem });

      if (_items.length >= MaxOrderItems) {
        this.setState({ ErrorMessage: `Er kunnen maximaal ${MaxOrderItems} artikelen toegevoegd worden` })
      } else {
        _items.push({
          Id: SelectedItem.Id,
          Title: SelectedItem.Title,
          ArticleNumber_MXI: SelectedItem.ArticleNumber_MXI,
          ArticleNumber_RAI: SelectedItem.ArticleNumber_RAI,
          Artikelgroep: SelectedItem.Artikelgroep,
          Quantity: quantity,
          Description: description
        });
        setStorage("OrderDetailRecover", JSON.stringify({
          OrderBasic: _orderBasic,
          Items: _items
        }));
        history.push({
          pathname: '/neworderadditems',
          state: {
            OrderBasic: _orderBasic,
            Items: _items
          }
        });
      }
    } else {
      this.setState({ ErrorMessageOnQuantity: "Aantal is verplicht" });
    }
  };

  private onTextChangeEvent = (name: string, value: string, data?: any) => {
    let _quntity: number = 0, _errorMessage: string = "";
    if (name == "Quantity") {
      if (Number(value) != NaN && Number(value) > 0) {
        _quntity = Number(value);
        _errorMessage = "";
      } else {
        _quntity = 0;
        _errorMessage = "Aantal is verplicht";
      }
    }

    if (name == "Quantity") {
      this.setState({ Quantity: _quntity, ErrorMessageOnQuantity: _errorMessage });
    } else if (name == "Description") {
      this.setState({ Description: value });
    }
  }

  private onHeaderBack = () => {
    let _orderBasic = history.location.state.OrderBasic;
    let _items = history.location.state.Items;

    history.push({
      pathname: '/itemcategory',
      state: { OrderBasic: _orderBasic, Items: _items }
    })
  }

  public render() {
    const { columns, isCompactMode, Items, Quantity, Description } = this.state;

    const currentEditItem = this.state.SelectedItem;

    return (
      this.state.ProgressStatus != ProgressStatus.Loaded ?
        <Loader PageTitle="<b>Artikel</b> scherm wordt geladen" /> :
        <div className="page">
          <Header isBackVisible={true} _onBack={this.onHeaderBack} />
          <div className="container mt-3">
            {
              this.state.ErrorMessage &&
              <MessageBar messageBarType={MessageBarType.error}>{this.state.ErrorMessage}</MessageBar>
            }
            <div className="row">
              <div className="col-12">
                <h3>{this.state.CategoryName}</h3>
              </div>
              <div className="col-12">
                <DetailsList
                  items={Items}
                  compact={isCompactMode}
                  columns={columns}
                  selectionMode={SelectionMode.none}
                  getKey={this._getKey}
                  setKey="none"
                  layoutMode={DetailsListLayoutMode.justified}
                  isHeaderVisible={false}
                  onItemInvoked={this._onItemInvoked}
                />
              </div>
            </div>
          </div>
          <EditItemPopup
            Key=""
            Id={0}
            ItemTitle={currentEditItem ? currentEditItem.Title : ""}
            ItemCategoryTitle={currentEditItem ? currentEditItem.Artikelgroep : ""}
            ItemNo_MXI={currentEditItem ? currentEditItem.ArticleNumber_MXI : 0}
            ItemNo_RAI={currentEditItem ? currentEditItem.ArticleNumber_RAI : 0}
            Quantity={Quantity}
            ErrorMessageOnQuantity={this.state.ErrorMessageOnQuantity}
            Description={Description}
            hideDialog={this.state.hideDialog}
            _onTextChangeEvent={this.onTextChangeEvent}
            _submitData={this.goForAddingItem}
            _cancel={this.cancelAdding}
          />
        </div>
    );
  }
}

const initialSelectedItem: IOrderItem = {
  Key: '',
  Id: 0,
  Title: '',
  ArticleNumber_MXI: 0,
  ArticleNumber_RAI: 0,
  Artikelgroep: '',
  Quantity: 0,
  Description: ''
}